import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import constant from "../../constant";
import { useAuth } from "../../components/context/AuthContext";

const REPORT_ROUTE_PATTERNS = [
  "/add-data-points/:id",
  "/rejected/:id",
  "/score-card/:id",
  "/team/data-points/:id",
  "/team/rejected/:id",
];

export default function useCopilotReportContext() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const reportId = useMemo(() => {
    for (const pattern of REPORT_ROUTE_PATTERNS) {
      const match = matchPath({ path: pattern, end: true }, location.pathname);
      if (match?.params?.id) {
        return match.params.id;
      }
    }
    return null;
  }, [location.pathname]);

  const backendApiUrl = useMemo(
    () => constant.BACKEDN_BASE_URL.replace(/\/$/, ""),
    [],
  );

  const authToken = isAuthenticated ? localStorage.getItem("token") : null;
  const toolType = "si";

  return { backendApiUrl, reportId, toolType, authToken };
}
